// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  WsTicketQueryDto,
  WsTicketReturnDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class WsTicketService {
  /**
   * GET /api/auth/ws-ticket
   */
  getWsTicket(
    dto: WsTicketQueryDto,
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<WsTicketReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/auth/ws-ticket';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
